/**
 * Vigencia helpers for the instrumentation step 1 "Vigencia" frame.
 * Pure functions: deterministic, no side effects, trivially testable.
 */

/** Today as ISO yyyy-MM-dd (local calendar date). */
export const todayIso = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Adds `years` to an ISO yyyy-MM-dd date, clamping Feb 29 → Feb 28
 * when the target year is not a leap year (JS Date semantics).
 */
export const addYears = (isoDate: string, years: number): string => {
  const [year, month, day] = isoDate.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setFullYear(date.getFullYear() + years);
  // Clamp Feb 29 → Feb 28 when the target year is not a leap year,
  // instead of letting JS Date roll over to Mar 1.
  if (month === 2 && day === 29 && date.getMonth() !== 1) {
    date.setMonth(2, 0); // day 0 of March = last day of February
  }
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export interface VigenciaDates {
  startDate: string;
  endDate: string;
}

export interface VigenciaErrors {
  startError?: string;
  endError?: string;
}

/**
 * Validates the vigencia frame: both dates required and end strictly after start.
 * Returns per-field error messages; empty object means valid.
 */
export const validateVigencia = ({
  startDate,
  endDate,
}: VigenciaDates): VigenciaErrors => {
  const errors: VigenciaErrors = {};
  if (!startDate) {
    errors.startError = 'Debe indicar la fecha de inicio de vigencia';
  }
  if (!endDate) {
    errors.endError = 'Debe indicar la fecha de fin de vigencia';
  }
  if (startDate && endDate && endDate <= startDate) {
    errors.endError = 'La fecha de fin debe ser posterior a la de inicio';
  }
  return errors;
};